function pauseAllModalVideos(dialog) {
  dialog.querySelectorAll('.in-your-space__modal-video').forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });
}

function openSlide(dialog, index) {
  dialog.querySelectorAll('[data-video-slide]').forEach((wrapper) => {
    const isTarget = wrapper.dataset.videoSlide === String(index);
    wrapper.hidden = !isTarget;

    const video = wrapper.querySelector('video');
    if (!video) return;

    if (isTarget) {
      video.currentTime = 0;
      video.muted = true;
      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => {});
    } else {
      video.pause();
      video.currentTime = 0;
    }
  });

  if (!dialog.open) dialog.showModal();
}

function closeDialog(dialog) {
  if (!dialog.open) return;
  pauseAllModalVideos(dialog);
  dialog.close();
}

function initTriggers() {
  document.querySelectorAll('[data-in-your-space-trigger]').forEach((trigger) => {
    if (trigger.dataset.iysBound) return;
    trigger.dataset.iysBound = 'true';

    trigger.addEventListener('click', () => {
      const dialog = document.querySelector('[data-in-your-space-dialog]');
      if (!dialog) return;

      openSlide(dialog, trigger.dataset.videoIndex);
    });
  });

  document.querySelectorAll('[data-in-your-space-dialog]').forEach((dialog) => {
    if (dialog.dataset.iysBound) return;
    dialog.dataset.iysBound = 'true';

    const closeButton = dialog.querySelector('[data-in-your-space-close]');
    closeButton?.addEventListener('click', () => closeDialog(dialog));

    // Native <dialog> doesn't light-dismiss on backdrop click by default -
    // only close when the click lands on the dialog element itself (the
    // backdrop area), not on its content.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });

    dialog.addEventListener('close', () => pauseAllModalVideos(dialog));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTriggers);
} else {
  initTriggers();
}

document.addEventListener('shopify:section:load', initTriggers);
